const PUBLIC_AUTH_TRANSACTION_PATHS = new Set([
    '/auth/account/restore',
    '/auth/account/restore-request',
    '/auth/apple',
    '/auth/apple/callback',
    '/auth/csrf',
    '/auth/facebook',
    '/auth/facebook/callback',
    '/auth/forgot-password',
    '/auth/google',
    '/auth/google/callback',
    '/auth/instagram',
    '/auth/instagram/callback',
    '/auth/login',
    '/auth/mfa/resend-login',
    '/auth/mfa/verify-login',
    '/auth/passkeys/authenticate/options',
    '/auth/passkeys/authenticate/verify',
    '/auth/register',
    '/auth/register-social',
    '/auth/register-social/mfa/resend',
    '/auth/register-social/mfa/resume',
    '/auth/register-social/mfa/verify',
    '/auth/reset-password',
    '/auth/unlock/request',
    '/auth/unlock/verify',
    '/auth/verify-email',
    '/auth/verify-reset-token',
]);
const PUBLIC_AUTH_TRANSACTION_PATTERNS = [
    /^\/auth\/[^/]+\/signup(?:\/callback)?$/,
    /^\/auth\/saml\/login\/[^/]+$/,
];
const SESSION_REFRESH_PATH = '/auth/refresh';
function normalizeAuthPath(requestUrl) {
    try {
        const pathname = new URL(requestUrl, 'https://idp.invalid').pathname.replace(/\/+$/, '');
        const normalized = pathname || '/';
        return normalized.startsWith('/api/') ? normalized.slice(4) : normalized;
    }
    catch {
        return null;
    }
}
/**
 * Prevents refresh recursion and preserves public authentication transaction
 * failures. Public transactions have no authenticated session to refresh;
 * refresh failures must also return directly instead of recursively refreshing.
 */
export function shouldSkipSessionRefresh(requestUrl) {
    if (typeof requestUrl !== 'string')
        return false;
    const path = normalizeAuthPath(requestUrl);
    if (!path)
        return false;
    return (path === SESSION_REFRESH_PATH ||
        PUBLIC_AUTH_TRANSACTION_PATHS.has(path) ||
        PUBLIC_AUTH_TRANSACTION_PATTERNS.some((pattern) => pattern.test(path)));
}
//# sourceMappingURL=session-refresh-policy.js.map